
<div class="row progress-bar" [class.progress-bar--big]="big" [class.hide]="!total">
  <div class="columns" [class.small-10]="showPercents &amp;&amp; !big" [class.small-12]="!showPercents || big">
    <div class="progress-bar__bar">
      <div class="progress-bar__progress" [style.width]="percents + '%'"></div>
      <div class="progress-bar__value" *ngIf="showPercents &amp;&amp; big">{{ percents | number: '1.0-0' }}%</div>
    </div>
  </div>
  <div class="columns small-2 progress-bar__value" *ngIf="showPercents &amp;&amp; !big">{{ percents | number: '1.0-0' }}%</div>
</div>